import infoo from "../plugins/infoo";
import Vue from "vue";

export const _sync = {
  mutable: false,
  multiple: false,
  source: ["create", "onChange"]
};

const auth = {
  namespaced: false,
  state: {
    auths: {},
    authDefault: {
      _source: "authDefault",
      _lastLogin: "",
      uid: "__",
      cred: {},
      created: "",
      name: "",
      photo: "/static/png/face.png",
      email: "",
      provider: ""
    },
    previouslyAuthenticated: {},
    uid: "__"
  },
  getters: {
    auth(state) {
      return state.auths[state.uid]
        ? state.auths[state.uid]
        : state.authDefault;
    }
  },
  mutations: {
    setAuth(state, auth) {
      Vue.set(state.auths, auth.uid, auth);
      state.uid = auth.uid;

      this.$local.set("user/auth/" + auth.uid, auth);
      this.$local.set("user/lastAuthUid", auth.uid);
    },
    previouslyAuthenticated(state, auth) {
      let obj = this.$local.get("users/previous");

      if (obj) {
        if (obj[auth.uid] === undefined) {
          obj[auth.uid] = auth;
          this.$local.set("users/previous", obj);
        }
      } else {
        obj = {};
        obj[auth.uid] = auth;
        this.$local.set("users/previous", obj);
      }

      Vue.set(state, "previouslyAuthenticated", obj);
    }
  },
  actions: {
    createInvitedAuth({ state, commit, dispatch }) {
      // TODO: validar que esto no se hizo antes
      let authCreate = JSON.parse(JSON.stringify(state.authDefault));
      authCreate._source = "authCreate";
      authCreate.name = ""; // Anonimo
      authCreate.email = ""; // Sin vincular
      authCreate.created = infoo.hoy.iso;

      commit("setAuth", authCreate);
      commit("previouslyAuthenticated", authCreate);
      dispatch("user/createInvitedLicencse", "", { root: true });
    },
    getAuth({ commit, dispatch }) {
      let uid = this.$local.get("user/lastAuthUid");
      let auth = uid ? this.$local.get("user/auth/" + uid) : null;

      if (auth) {
        // correccion ausencia en la fecha
        if (auth.created === undefined) {
          let license = this.$local.get("user/licenses/" + auth.uid);
          auth.created = license ? license.ini : "2020-05-01";
          // la fecha corresponde al lanzamiento en portugues
          this.$local.set("user/auth/" + auth.uid, auth);
        }
        // fin correcion
        commit("setAuth", auth);
        commit("previouslyAuthenticated", auth);
      } else {
        dispatch("createInvitedAuth");
      }

      return;
    },
    async onAuthChange({ state, commit, dispatch }, auth) {
      if (auth) {
        let authOnChange = JSON.parse(JSON.stringify(state.authDefault));
        authOnChange._source = "authOnChange";
        authOnChange._lastLogin = infoo.timeStamp();
        authOnChange.uid = auth.uid;

        commit("setAuth", authOnChange);
        commit("previouslyAuthenticated", authOnChange);

        // sincronizar config / si es el primer inicio | duplica esa config al nuevo usuario | elimina esa config del usuario invitado
        // sincronizar notas /  si es el primer inicio...
        // sincronizar licencias / lo mismo...
      } else {
        // establecemos el ultimo ususario activo como invitado
        this.$local.set("user/lastAuthUid", "__");
        await dispatch("getAuth");

        // get user config
        await dispatch("user/getConfig", "", { root: true });

        // get user config
        await dispatch("user/getLicense", "", { root: true });

        if (this.$router.currentRoute.name !== "home") {
          this.$router.push({ name: "home" }).catch(e => {
            // TODO: enviar error a base de datos
            console.log(e);
          });
        }
      }
    }
  }
};

export default auth;
